import _ from "lodash";
import client from "lib/apolloClient/client";
import { getLTIServicesForCurriculumQuery } from "./LTIQueries";

export const getLTIServicesForCurriculumFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getLTIServicesForCurriculumQuery,
      variables,
    });
    return _.get(queryData, "integration", {});
  } catch (e) {
    return {};
  }
};
